<div class="container my-3">
  <div class="row mb-3">
    <div class="col-md-12" *ngIf="!isAdmin">
      <div class="input-group">
        <input type="text" class="form-control" placeholder="Buscar..." [(ngModel)]="searchQuery" (input)="search()" />
        <div class="input-group-text" *ngIf="isLoading">
          <div class="spinner-border spinner-border-sm" role="status">
            <span class="visually-hidden">Carregando...</span>
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-6" *ngIf="isAdmin">
      <div class="input-group">
        <input type="text" class="form-control" placeholder="Buscar..." [(ngModel)]="searchQuery" (input)="search()" />
        <div class="input-group-text" *ngIf="isLoading">
          <div class="spinner-border spinner-border-sm" role="status">
            <span class="visually-hidden">Carregando...</span>
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-6" *ngIf="isAdmin">
      <select class="form-select" [(ngModel)]="selectedJobTitle" (change)="filterByJobTitle()">
        <option value="">Todos os Cargos</option>
        <option *ngFor="let job of getUniqueJobTitles()" [value]="job">{{ job }}</option>
      </select>
    </div>
  </div>

  <div class="table-responsive">
    <!-- Loading overlay -->
    <div *ngIf="isLoading" class="loading-overlay">
      <div class="loading-content">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Buscando...</span>
        </div>
        <p class="mt-2">Buscando rotinas...</p>
      </div>
    </div>

    <table class="table table-hover" [class.loading]="isLoading">
      <thead class="thead-light">
        <tr>
          <th *ngFor="let header of headers">
            <ng-container *ngIf="header == headers[0]; else elseTemplate" hidden></ng-container>
            <ng-template #elseTemplate>
              {{ header }}
            </ng-template>
          </th>
          <th *ngIf="isAdmin">Ações</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of paginatedData">
          <td *ngFor="let col of row; let i = index">
            <span *ngIf="i === 0" hidden>{{ col }}</span>
            <!-- <img *ngIf="i===1" [src]="col" alt="photo" class="img-thumbnail" width="70" height="70" /> -->
            <span *ngIf="i === 1">{{ col }}</span>
            <span *ngIf="i !== 0 && i !== 1">{{ col }}</span>
          </td>
          <td *ngIf="isAdmin">
            <button class="btn btn-primary btn-sm me-1" (click)="onEdit(row)">
              <i class="bi bi-pencil-fill"></i>
            </button>
            <button class="btn btn-danger btn-sm" (click)="onDelete(row)">
              <i class="bi bi-trash-fill"></i>
            </button>
          </td>
        </tr>
      </tbody>
    </table>

    <!-- Mensagem quando não há resultados -->
    <div *ngIf="!isLoading && paginatedData.length === 0" class="no-results">
      <div class="text-center py-4">
        <i class="bi bi-search text-muted" style="font-size: 2rem;"></i>
        <p class="text-muted mt-2">Nenhuma rotina encontrada</p>
        <small class="text-muted">Tente ajustar os filtros de busca</small>
      </div>
    </div>
  </div>

  <nav aria-label="Table pagination">
    <ul class="pagination justify-content-center">
      <li class="page-item" [class.disabled]="currentPage === 1">
        <button class="page-link" (click)="changePage(currentPage - 1)" [disabled]="currentPage === 1">Anterior</button>
      </li>
      <li
        class="page-item"
        *ngFor="let page of [].constructor(totalPages); let i = index"
        [class.active]="i + 1 === currentPage"
      >
        <button class="page-link" (click)="changePage(i + 1)">
          {{ i + 1 }}
        </button>
      </li>
      <li class="page-item" [class.disabled]="currentPage === totalPages">
        <button class="page-link" (click)="changePage(currentPage + 1)" [disabled]="currentPage === totalPages">
          Próximo
        </button>
      </li>
    </ul>
  </nav>
</div>
